"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotStatus = void 0;
var react_1 = __importStar(require("react"));
var LotStatus = function (props) {
    var lot_status = props.lot_status;
    var _a = (0, react_1.useState)(lot_status !== null && lot_status !== void 0 ? lot_status : ""), status = _a[0], setStatus = _a[1];
    var _b = (0, react_1.useState)(""), backgroundColor = _b[0], setBackgroundColor = _b[1];
    (0, react_1.useEffect)(function () {
        if (lot_status) {
            setStatus(lot_status);
            //       console.log("status", lot_status);
            switch (lot_status) {
                case "Bidding Open":
                    setBackgroundColor("bg-yellow-500");
                    break;
                case "Withdrawn":
                    setBackgroundColor("bg-red-500");
                    break;
                case "Sold":
                    setBackgroundColor("bg-green-500");
                    break;
                case "Passed":
                    setBackgroundColor("bg-blue-500");
                    break;
                case "Bidding Closed":
                    setBackgroundColor("bg-blue-500");
                    break;
                case "Reserve Not reached":
                    setBackgroundColor("bg-blue-500");
                    break;
                case "Subject to Confirm":
                    setBackgroundColor("bg-blue-500");
                    break;
                default:
                    setBackgroundColor("bg-gray-500");
                    break;
            }
        }
    }, [lot_status]);
    return (react_1.default.createElement("div", { className: "\n        rounded-md p-1 text-black text-xs \n        ".concat(backgroundColor, "\n      ") }, status));
};
exports.LotStatus = LotStatus;
